var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConnectionIssues(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 179,
    height: 167,
    viewBox: "0 0 179 167",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.4281 75.2456L26.5712 75.4321L26.7229 75.6117L78.9156 137.407L78.9158 137.407C83.5589 142.905 91.7824 143.597 97.2777 138.943C97.8309 138.475 98.3439 137.961 98.8116 137.407C98.8134 137.405 98.8151 137.403 98.8169 137.401L151.005 75.6121L151.005 75.6114C155.839 69.8875 154.726 61.6981 149.345 57.1555L149.166 57.0041L148.98 56.8613C130.469 42.6659 110.364 35.2463 88.8639 35.2463C67.364 35.2463 47.2582 42.6658 28.748 56.861C22.7968 61.4244 22.1469 69.6644 26.4281 75.2456Z",
    stroke: "#F84244",
    strokeWidth: 20
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8682 67.3694C98.8682 61.8465 94.391 57.3694 88.8682 57.3694C83.3453 57.3694 78.8682 61.8465 78.8682 67.3694V78.4309C78.8682 83.9537 83.3453 88.4309 88.8682 88.4309C94.391 88.4309 98.8682 83.9537 98.8682 78.4309V67.3694Z",
    stroke: "#F84244",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M81.431 93.9239C77.739 98.0313 78.0758 104.354 82.1832 108.046C86.2906 111.738 92.6133 111.401 96.3053 107.294L96.3608 107.232C100.053 103.125 99.7161 96.802 95.6087 93.11C91.5013 89.418 85.1786 89.7547 81.4866 93.8621L81.431 93.9239Z",
    stroke: "#F84244",
    strokeWidth: 20,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3626 69.1592C33.2547 67.7149 33.5069 65.8134 34.833 64.7966C51.8284 51.7631 69.8386 45.2463 88.8639 45.2463C107.889 45.2463 125.899 51.7631 142.894 64.7966C144.285 65.9705 144.444 67.8822 143.365 69.1595L91.1719 130.955C91.0637 131.083 90.945 131.202 90.8169 131.31C89.5423 132.391 87.634 132.232 86.5553 130.955L34.3626 69.1592Z",
    fill: "#FC8D66"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3618 72.2281L30.434 72.3221L30.5104 72.4127L82.7032 134.208L82.7032 134.208C85.5792 137.613 90.6718 138.041 94.0746 135.159C94.417 134.869 94.7346 134.551 95.024 134.208C95.0249 134.207 95.0258 134.206 95.0267 134.205L147.217 72.413L147.217 72.4127C150.189 68.8933 149.549 63.8162 146.147 60.9437L146.056 60.8674L145.963 60.7954C128.203 47.176 109.137 40.2041 88.8639 40.2041C68.5908 40.2041 49.524 47.176 31.7648 60.7953C28.1066 63.6004 27.6539 68.6979 30.3618 72.2281Z",
    stroke: "#2A2A2A",
    strokeWidth: 10.0845
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9104 67.3694C93.9104 64.5846 91.6529 62.3271 88.8682 62.3271C86.0834 62.3271 83.8259 64.5846 83.8259 67.3694V78.4309C83.8259 81.2157 86.0834 83.4732 88.8682 83.4732C91.6529 83.4732 93.9104 81.2157 93.9104 78.4309V67.3694Z",
    stroke: "#2A2A2A",
    strokeWidth: 10.0845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M85.1182 97.2381C83.2566 99.3092 83.4264 102.497 85.4974 104.359C87.5685 106.22 90.7565 106.051 92.6182 103.98L92.6737 103.918C94.5353 101.847 94.3655 98.6587 92.2944 96.7971C90.2234 94.9355 87.0353 95.1053 85.1737 97.1764L85.1182 97.2381Z",
    stroke: "#2A2A2A",
    strokeWidth: 10.0845,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionIssues);
export default __webpack_public_path__ + "static/media/ConnectionIssues.8a656f632c5666fece745e9f3bd662e7.svg";
export { ForwardRef as ReactComponent };